module.exports = __webpack_public_path__ + "img/cat-5.db906e9a.svg";